import { Stack } from "@mui/material";
import { Fragment } from "react"
import { auditLogReports, User } from "../../../model/auditlogreports";
import { timeFilterMenus } from "./ReportCriteriaSelection";

const ReportHeader = ({ reportType, filterBy, users }: reportHeaderProps) => {
    return (
        <Fragment>
            <Stack
                sx={{
                    fontFamily: 'Montserrat, Roboto, "Helvetica Neue", Arial, sans-serif',
                    fontSize: '1.5rem',
                    lineHeight: '1.334',
                    color: 'rgb(29, 99, 159)',
                    fontWeight: '600',
                    marginBottom: '0.5rem'
                }}>
                {auditLogReports[reportType].title}
            </Stack>
            <Stack
                sx={{
                    fontFamily: 'Montserrat, Roboto, "Helvetica Neue", Arial, sans-serif',
                    fontSize: '0.8rem',
                    lineHeight: '1.334',
                    color: 'rgb(29, 99, 159)',
                    fontWeight: '600',
                    marginBottom: '0.5rem'
                }}>
                {timeFilterMenus.find(tfm => tfm.value == filterBy)?.label} / {users.findIndex(u => u.id == 'allUsers') == -1 ? 'Selected Users' : 'All Users'}
            </Stack>
        </Fragment>
    )
}

type reportHeaderProps = {
    reportType: string
    filterBy: string
    users: User[]
}

export default ReportHeader;